import React, { useEffect, useState } from "react";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import api from "api";

const EchoConfig = {
    reverbAppKey: 'e647a1941832fe62dea69503d80da613', // Your REVERB_APP_KEY
    reverbHost: 'api.zippertic.se', // Your REVERB_HOST
    reverbPort: 443, // Your REVERB_PORT
    reverbScheme: 'https', // 'http' or 'https'
};

const config = {
    broadcaster: 'reverb',
    key: EchoConfig.reverbAppKey,
    wsHost: EchoConfig.reverbHost,
    wsPort: EchoConfig.reverbPort,
    wssPort: EchoConfig.reverbPort,
    forceTLS: EchoConfig.reverbScheme === 'https',
    enabledTransports: ['ws', 'wss'],
};

export const MODE_PREDRAW = 'predraw';
export const MODE_DRAW = 'draw';

function useJumbotron({ eventId }) {
    const [state, setState] = useState({});

    useEffect(() => {
        // Initialize Echo
        const echo = new Echo(config);
        // Connection event listeners (optional)
        echo.connector.pusher.connection.bind('connected', () => {
            console.log('✅ WebSocket connected');
        });

        echo.connector.pusher.connection.bind('disconnected', () => {
            console.log('❌ WebSocket disconnected');
        });

        echo.connector.pusher.connection.bind('error', (error) => {
            console.error('❌ WebSocket error:', error);
        });

        // Subscribe to the 'test' channel
        const channel = echo.channel(`lottery.winner.${eventId}`);

        // Listen for subscription success
        channel.subscribed(() => {
            api.get({ path: `/api/display/events/${eventId}/lottery/current-winner` }).then(response => {
                console.log('Subscribed');
            });
            channel.listen('.winner.drawn', (data) => {
                setState(data);
            });
            channel.listen('winner.drawn', (data) => {
                setState(data);
            });            
        });
    }, [eventId]);


    //Workaround to unlock socket
    useEffect(() => {
        if (state.has_winners !== undefined) {
            return;
        }
        const timeoutID = setTimeout(() => {
            api.get({ path: `/api/display/events/${eventId}/lottery/current-winner` }).then(response => {
                console.log('refresh data');
            });
        }, 1000);

        return () => clearTimeout(timeoutID);
    }, [eventId, state]);

    return {
        ready: state.has_winners !== undefined,
        mode: state.has_winners == true ? MODE_DRAW : MODE_PREDRAW,
        items: state.item_ids || [],
        price_pool: state.price_pool || 0,
        price_amount_raw: state.price_amount_raw || 0,
    };
}

export default useJumbotron;